import { render } from "./UsersForm.vue?vue&type=template&id=afb97592&scoped=true"
import script from "./UsersForm.vue?vue&type=script&lang=js"
export * from "./UsersForm.vue?vue&type=script&lang=js"

import "./UsersForm.vue?vue&type=style&index=0&id=afb97592&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb97592"]])

export default __exports__